import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseAsset: {
      code: 'BTC',
      issuer: 'GBSTRH4QOTWNSVA6E4HFERETX4ZLSR3CIUBLK7AXYII277PFJC4BBYOG',
      trustline: null
    },
    quoteAsset: {
      code: 'XLM'
    },
    account: null,
    asks: [],
    bids: []
  },
  mutations: {
    setBaseAsset (state, asset) { state.baseAsset = asset },
    setQuoteAsset (state, asset) { state.quoteAsset = asset },
    setAccount (state, obj) { state.account = obj },
    setAsks (state, asks) { state.asks = asks },
    setBids (state, bids) { state.bids = bids }
  },
  actions: {
    swapAssets ({ commit, state }) {
      let tempAsset = state.baseAsset
      commit('setBaseAsset', state.quoteAsset)
      commit('setQuoteAsset', tempAsset)
    },
    logOut ({ commit }) { commit('setAccount', null) }
  },
  getters: {
    baseMarketPrice (state) {
      if (state.asks[0]) return state.asks[0].price
      else return null
    }
  }
})
